







































































































































































import {
  Component, Ref, Vue, Watch,
} from 'vue-property-decorator';
import {
  addDays, addMonths, endOfMonth, format, lastDayOfMonth,
} from 'date-fns';
import { Message } from 'element-ui';
import { find } from 'lodash';

import ScanField from '@/components/ScanField.vue';
import Deferred from '@/utils/deferred';
import { formatMoney } from '@/utils/format';
import BankAccountsModule from '@/store/bank-accounts';
import { BankAccount } from '@/api/payment-orders';
import MoneyInput from '@/components/inputs/MoneyInput.vue';
import ChoosePartyModal from '@/components/ChoosePartyModal.vue';
import EIRAModule from '@/store/e-ira';
import TransactionDto from '@/interfaces/transaction.dto';
import { IBAN } from '@/enums/iban.enum';
import EIRAItem from '@/models/EIRAItem';
import ServiceType from '@/models/ServiceType';

@Component({
  components: {
    ChoosePartyModal, MoneyInput, ScanField,
  },
})
export default class EIRA extends Vue {
  @Ref('page') readonly pageRef!: HTMLDivElement;

  isScanMode = true;

  isScanModeBeforeModalOpen = false;

  isPartyModalOpen = false;

  party: Partial<BankAccount> | null = null;

  partyDeferred: Deferred<BankAccount> | null = null;

  @Ref('scanField')
  readonly scanField!: ScanField;

  @Watch('isPartyModalOpen')
  async onIsPartyModalOpenChange(newValue: boolean) {
    if (newValue) {
      this.isScanModeBeforeModalOpen = this.isScanMode;
    } else if (this.isScanModeBeforeModalOpen) {
      window.setTimeout(() => {
        this.isScanMode = true;
        this.scanField.focusScanArea();
      }, 1000);
    }
  }

  get parties(): BankAccount[] | null {
    return BankAccountsModule.bankAccounts;
  }

  get taxRates(): number[] {
    return [0.05, 0.13, 0.25];
  }

  get items(): EIRAItem[] {
    return EIRAModule.items;
  }

  formatDate(date: Date) {
    return format(date, 'dd.MM.yyyy');
  }

  openPartyModal() {
    this.isPartyModalOpen = true;
  }

  closePartyModal() {
    this.isPartyModalOpen = false;
  }

  async chooseParty(party: BankAccount | null) {
    this.party = party;

    this.openPartyModal();

    this.partyDeferred = new Deferred<BankAccount>();

    const tmp = await this.partyDeferred;

    this.partyDeferred = null;

    return tmp;
  }

  async onScannerInput(transactionDto: TransactionDto | null) {
    if (!transactionDto) {
      Message.error('Skeniranje neuspješno!');

      return;
    }

    const {
      amount, crdtrNm, crdtrIban, dbtrNm, dbtrAddr, ref,
    } = transactionDto;

    let serviceType: ServiceType;

    switch (crdtrIban) {
    case IBAN.BUILDINGS_MANAGEMENT:
      serviceType = ServiceType.MANAGEMENT;
      break;
    case IBAN.HEATING:
      serviceType = ServiceType.HEATING;
      break;
    default:
      Message.error(`Nepoznata vrsta usluge prema ibanu: "${crdtrIban}"`);
      return;
    }

    // const result = /^(\d{4,15})-(\d{2})(\d{4})$/.exec(ref);

    // BUILDING MANAGEMENT
    const result = serviceType.refParser(ref);

    if (!result) {
      Message.error('Pogrešan format poziva na broj.');
      return;
    }

    const { year, month, invoiceNumber } = result;

    console.log({
      result, month, year, invoiceNumber,
    });

    const invoiceDate = endOfMonth(new Date(Number(year), Number(month) - 1));

    let payer = find(this.parties, ['name', dbtrNm]) || find(this.parties, ['name', dbtrAddr]);

    if (!payer) {
      const bankAccount = BankAccount.default();
      bankAccount.name = dbtrNm;

      payer = await this.chooseParty(bankAccount);
    } else if (!payer.synesisCode) {
      payer = await this.chooseParty(payer);
    }

    if (!payer) {
      Message.error('Platitelj nije odabran');
      return;
    }

    const { taxRate } = serviceType;
    const invoiceId = `${Number(invoiceNumber)}/${serviceType.invoiceId}`;

    const invoiceDueDate = serviceType.daysDue !== null
      ? addDays(invoiceDate, serviceType.daysDue)
      : lastDayOfMonth(addMonths(invoiceDate, 1));

    EIRAModule.ADD_ITEM({
      invoiceId,
      payer,
      payee: crdtrNm,
      amount,
      taxRate,
      interest: 0,
      invoiceDate,
      invoiceDueDate,
    });

    Message.success('Skeniranje uspješno!');

    await this.$nextTick();

    this.pageRef.scrollTop = this.pageRef.scrollHeight;
  }

  handleDelete(index: number) {
    this.items.splice(index, 1);
  }

  onGenerate() {
    console.log('generate');

    console.log(this.items);

    EIRAModule.generate();
  }

  formatMoney(amount: number) {
    return formatMoney(amount);
  }

  onPartySelect(party: BankAccount) {
    // eslint-disable-next-line no-unused-expressions
    this.partyDeferred?.resolve(party);

    this.closePartyModal();
  }
}
